import React, { useEffect, useState} from 'react'
// import AuthContext from '../../context/autenticacion/authContext'
import Element from './Element'
// import {LanguageContext, Text} from '../../context/language/LanguageContext';
// import Layout from '../../layout';
import Button from '../styleComponents/Button';
import Layout from '../styleComponents/Layout';
import {verifyRequiredQuestion} from '../../helpers';
import CustomModal from '../styleComponents/CustomModal';
import { useAppContext } from '../../AppContext';
// import ModalSend from '../styleComponents/ModalSend';

const Array = (props) => {
    const { text, limitPage, currentPage, stepPages, setCurrentPage, elements, setStepPages} = props

    const { globalState, setGlobalState } = useAppContext();
    // const authContext = useContext(AuthContext)
    // const {lang} = useContext(LanguageContext);

    // const {sendAnswers, nextQuestion, estudio, isRecording} = authContext

    const [open, setOpen] = useState(false);
    const [buttonIsDisabled] = useState(false);
    const [ setMultipleModal] = useState(false)
    const [modalSend] = useState(false)

    const onOpenModal = () => setOpen(true);
    const onCloseModal = () => setOpen(false);

    let item = text;
    let step = 1;
    // let back = 1;

    let salto = stepPages.find((a) => a[0] === currentPage)
    // let saltoBack = stepPages.find((a) => a[2] === currentPage)


    if (salto) {
        step = 1 + salto[1]
    }

    // if (saltoBack) {
    //     back = 1 + saltoBack[1]
    // }


    useEffect(() => {
        // setResponse(
        //     {...elements, currentPage, skips: stepPages, language: lang, respondentName: estudio.firstName}
        // )
    }, [elements])
    
    // useEffect(() => {
        // 
        // setButtonIsDisabled(isRecording)
    // }, [isRecording])


    const onClickNext = () => {
        switch (item.type) {
            case 'scale':
            case 'scale_nps':
            case 'scale_smileys':
            case 'image_choice_single':
                if (!item.answer && item.required) {
                    onOpenModal()
                } else {
                    //setButtonIsDisabled(true)
                    // setModalSaved(true)
                    setPage()
                }
                break;
            case 'video_recording':
            case 'audio_recording':    
            case 'short_answer':  
            if (!item.answer && item.required) {
                onOpenModal()
            } else {
                //setButtonIsDisabled(true)
                // (true)
                // nextQuestion(response, setPage)
                setPage()
            }
                break;
            case 'single_choice':
                if (!item.answer && item.required) {
                    onOpenModal()
                } else {
                    let jump = false;
                    const jumpTo = item.answers.filter(answer => answer.jumpTo)
                    if (jumpTo) {
                        let salto = jumpTo.find(a => a.label === item.answer)
                        if (salto) {
                            item['jumpHasta'] = salto.jumpTo;
                            jump = true;
                            setStepPages(prev => {
                                return [
                                    ...prev,
                                    [currentPage, salto.jumpTo - currentPage, salto.jumpTo + 1]
                                ]
                            })
                            setCurrentPage(salto.jumpTo + 1)
                        } else {
                            jump = false
                            item['jumpHasta'] = false;
                            //setButtonIsDisabled(true)
                            // (true)
                            setPage()
                        }
                    }
                    item['jumpTo'] = jump;
                }
                break

            case 'link_question':
            case 'video_question':
                if ((!item.subtype && item.required)) {
                    onOpenModal()
                } else if (item.subtype === 'videoQuestionText' && item.required && !item.answer) {
                    onOpenModal()
                } else if (item.subtype !== 'videoQuestionText' && item.required && !item.file) {
                    onOpenModal()
                } else {
                    //setButtonIsDisabled(true)
                    // (true)
                    // nextQuestion(response, setPage)
                }
                break;
            case 'category':
                let countOptions = 0;
                try {
                    if ((item.answers).length > 0) {
                        (item.answers).forEach(function (option, key) {
                            countOptions += (option.options).length;
                        })
                        if (countOptions === (item.options).length) {
                            //setButtonIsDisabled(true)
                            // (true)
                            // nextQuestion(response, setPage)
                        } else {
                            return onOpenModal()
                        }
                    } else {
                        return onOpenModal()
                    }
                } catch (e) {
                    return onOpenModal()
                }
                break;
            case 'image_choice_multiple':
                if (item.required && item.answers.length === 0) {
                    return onOpenModal()
                } else {
                    //setButtonIsDisabled(true)
                    // (true)
                    // nextQuestion(response, setPage)
                }
                break;
            case 'multiple_choice':
                const {required, minimumOptions, maximumOptions, answers} = item
                if (required && (!answers || answers.length === 0)) return onOpenModal()
                if (minimumOptions && answers.length < minimumOptions) return setMultipleModal(true)
                if (maximumOptions && answers.length > maximumOptions) return setMultipleModal(true)
                //setButtonIsDisabled(true)
                // (true)
                // nextQuestion(response, setPage)
                setPage()
                break;

            case 'ranking':
                if (!item.answersR && item.required) {
                    onOpenModal()
                } else {
                    setPage()
                    //setButtonIsDisabled(true)
                    // (true)
                    // nextQuestion(response, setPage)
                }
                break;
            case 'image_answer':
                if (item.required && !item.answers) {
                    onOpenModal()
                } else if (item.required && item.answers.length === 0) {
                    onOpenModal()
                } else {
                    //setButtonIsDisabled(true)
                    // (true)
                    // nextQuestion(response, setPage)
                }
                break;
            case 'video':
                if (item.required && !item.dialTesting) {
                    onOpenModal()
                } else {
                    //setButtonIsDisabled(true)
                    // (true)
                    setPage()
                }
                break;

            case 'video_content':
                if (!item.answer && item.required) {
                    onOpenModal()
                } else {
                    //setButtonIsDisabled(true)
                    // (true)
                    // nextQuestion(response, setPage)
                }
                break
            case 'link_content':
            case 'text_content':
            case 'image_content':
                // nextQuestion(response, setPage)
                break;

            default:
                break;
        }
    }

    const setPage = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        if (limitPage === currentPage) {
            return
        }
        
        if (item.type === 'multiple_choice' || item.type === 'image_choice_multiple') item.answered = true
        // setButtonIsDisabled(false)
        // (false)
        props.setCurrentPage(props.currentPage + step)
    }


    // const onClickPrev = () => {
    //     props.setCurrentPage(props.currentPage - back)
    // }


    const onSubmit = () => {
        if (verifyRequiredQuestion(item, onOpenModal, setMultipleModal)) {
            // setModalSend(true)
            // sendAnswers({data: elements})
            setGlobalState({
                ...globalState,
                step: "4",
                questions: elements,
              });
        }
    }

    return (
        <Layout>
            <form onSubmit={e => e.preventDefault()}>
                <Element
                    item={item}
                    limitPage={limitPage}
                    page={currentPage}
                    setPage={setCurrentPage}
                />
                <div
                    className={`d-flex mb-2 justify-content-${currentPage < 2 ? 'end' : 'center'} align-items-center gap-3 ${item.type === "single_choice" && "questionContainer"} `}>
                    {/* {currentPage > 1
                        && <Button type="button" onClick={onClickPrev} back={true}>
                            Anterior
                        </Button>
                    } */}
                    {
                        currentPage === limitPage
                            ? <Button type='button' onClick={onSubmit} disabled={modalSend}>
                                Continuar
                            </Button>
                            : <Button type='button' onClick={onClickNext} disabled={buttonIsDisabled}>
                                Continuar
                            </Button>
                    }
                </div>
            </form>
            <CustomModal isOpenModal={open} onClose={onCloseModal} title={'¡Aviso!'}>
                <h2 className="text-white">Es necesario tu respuesta</h2>
            </CustomModal>
            {/* <ModalSend isOpenModal={modalSend} onClose={()=> setModalSend(true)} title={`${lang === 'en' ? 'Notice!' : '¡Aviso!'}`}>
                <h2><Text tid='message.sendAnswers'/></h2>
            </ModalSend>
            <ModalSend isOpenModal={modalSaved} onClose={()=> setModalSend(true)} title={`${lang === 'en' ? 'Saving!' : '¡Guardando!'}`}>
                
            </ModalSend> */}
            {/* <CustomModal isOpenModal={multipleModal} onClose={() => setMultipleModal(false)}
                         title={`${lang === 'en' ? 'Notice!' : '¡Aviso!'}`}>
                {
                    item.maximumOptions
                    && !item.minimumOptions
                    && <h2><Text tid="message.modalMaximum"/> {item.maximumOptions} <Text
                        tid="message.modalLimitBetweenMax"/></h2>
                }
                {
                    item.minimumOptions
                    && !item.maximumOptions
                    && <h2><Text tid="message.modalMinimum"/> {item.minimumOptions} <Text
                        tid="message.modalLimitBetweenMax"/></h2>
                }
                {
                    item.maximumOptions
                    && item.minimumOptions
                    &&
                    <h2><Text tid="message.modalLimitBetweenMin"/> {item.minimumOptions} - {item.maximumOptions} <Text
                        tid="message.modalLimitBetweenMax"/></h2>
                }
            </CustomModal> */}
        </Layout>
    );
}

export default Array
